<template>
 <q-tabs
    v-model="currentTab"
    dense
    class="text-grey"
    active-color="primary"
    indicator-color="primary"
    align="left"
    narrow-indicator
    @update:model-value="changeRoute"
  >

  <q-tab name="PromotionTagesberichteinzelauswertung" label="Einsätze" />
  <q-route-tab name="planungsuebersicht"  @click="goto('/planungsuebersicht/'+id_promotion)" label="Planungsübersicht" />
  <q-tab name="PromotionJobnummern" label="Jobnummern " />

  <!-- <q-tab name="PromotionFaxe" label="Faxe" /> -->
  <!-- <q-tab name="PromotionLocations" label="Locations" /> -->
  <!-- <q-route-tab name="tourenplanung"  @click="goto('/tourenplanung/'+id_promotion)" label="Tourenplanung" /> -->
  <!-- <q-route-tab name="produkte"  @click="goto('/produkte/'+id_promotion)" label="Produkte" /> -->
  <q-tab name="PromotionStammdaten" label="Stammdaten" />
  <!-- <q-route-tab name="waren"  @click="goto('/waren/'+id_promotion)" label="Waren" /> -->
  <!-- <q-route-tab name="meineBestellungen"  @click="goto('/meineBestellungen')" label="Bestellungen" /> -->

  <!-- <q-btn-dropdown auto-close stretch flat  label="Listen">
  <q-list>
      <q-item clickable @click="goto('/offeneAuftragsnummern/'+id_promotion)">
        <q-item-section>Neue Auftragsnummern</q-item-section>
      </q-item>
      <q-item clickable @click="goto('/nichtFreigegebeneEinsaetze/'+id_promotion)">
        <q-item-section>Nicht freigegebene Einsätze</q-item-section>
      </q-item>
      <q-item clickable @click="goto('/promoterMitFehlendenDokumenten/'+id_promotion)">
        <q-item-section>Promoter mit fehlenden Dokumenten</q-item-section>
      </q-item>
      <q-item clickable @click="goto('/neueTvppProdukte/'+id_promotion)">
        <q-item-section>Neue TVPP Produkte</q-item-section>
      </q-item>
      <q-item clickable @click="goto('/tvppOrders')">
        <q-item-section>RSA Orders</q-item-section>
      </q-item>
      <q-item clickable @click="goto('/wechselProdukte/'+id_promotion)">
        <q-item-section>Wechsel-Produkte</q-item-section>
      </q-item>



  </q-list>
</q-btn-dropdown> -->


    <q-btn-dropdown auto-close stretch flat  label="BAT">

      <q-list>


        <q-item clickable @click="goto('/batTrials/'+id_promotion)">
          <q-item-section>Trials</q-item-section>
        </q-item>
        <q-item clickable @click="goto('/unzugeordneteTrials/'+id_promotion)">
          <q-item-section>Unzugeordnete Trials</q-item-section>
        </q-item>

        <q-item clickable @click="goto('/waren/'+id_promotion)">
          <q-item-section>Waren-Administration</q-item-section>
        </q-item>
        <q-item clickable @click="goto('/warenshop/'+id_promotion)">
          <q-item-section>Shop</q-item-section>
        </q-item>
        <q-item clickable @click="goto('/meineBestellungen/'+id_promotion)">
          <q-item-section>Bestellungen</q-item-section>
        </q-item>
        <q-item clickable @click="goto('/lagertransaktionen/'+id_promotion)">
          <q-item-section>Transaktionen</q-item-section>
        </q-item>
        <q-item clickable  @click="goto('/batTrialsSummary/'+id_promotion)">
              <q-item-section>BAT Übersicht</q-item-section>
            </q-item>


      </q-list>
    </q-btn-dropdown>




    <q-btn-dropdown auto-close stretch flat  label="Weitere">


          <q-list>


      <q-item clickable @click="goto('/produkte/'+id_promotion)">
              <q-item-section>Produkte</q-item-section>
            </q-item>
            <q-item clickable @click="goto('/promotion/'+id_promotion+'/Locations')">
              <q-item-section>Locations</q-item-section>
            </q-item>

            <q-item clickable @click="goto('/verkaufsregeln/'+id_promotion)">
              <q-item-section>Verkaufsregeln</q-item-section>
            </q-item>

            <!-- <q-item clickable @click="changeRoute('PromotionLocations')">
              <q-item-section>Locations</q-item-section>
            </q-item> -->
            <q-item clickable @click="changeRoute('PromotionExport')">
              <q-item-section>Export</q-item-section>
            </q-item>
            <q-item clickable @click="changeRoute('PromotionImport')">
              <q-item-section>Importe</q-item-section>
            </q-item>
             <q-item clickable @click="changeRoute('PromotionSettings')">
              <q-item-section>Einstellungen</q-item-section>
            </q-item>

            <q-item clickable @click="changeRoute('PromotionZugriff')">
              <q-item-section>Zugriff</q-item-section>
            </q-item>

            <q-item clickable @click="goto('/promotionpromoter/'+id_promotion)">
              <q-item-section>Promoter</q-item-section>
            </q-item>
            <q-item clickable @click="goto('/auftragsnummernsuche/'+id_promotion)">
              <q-item-section>Auftragsnummern-Suche</q-item-section>
            </q-item>
            <q-item clickable @click="changeRoute('PromotionAuftragsnummernfreigabe')">
              <q-item-section>Auftragsnummern-Freigabe</q-item-section>
            </q-item>
            <q-item clickable @click="changeRoute('PromotionAuftragsnummernfeedback')">
              <q-item-section>Auftragsnummern-Feedback</q-item-section>
            </q-item>
            <q-item clickable @click="changeRoute('PromotionIncentiveVergabe')">
              <q-item-section>Incentive-Vergabe</q-item-section>
            </q-item>

             <q-item clickable @click="changeRoute('PromotionDateien')">
              <q-item-section>Dateien</q-item-section>
            </q-item>
             <q-item clickable @click="changeRoute('PromotionFragen')">
              <q-item-section>Fragen</q-item-section>
            </q-item>
             <q-item clickable @click="changeRoute('PromotionAntworten')">
              <q-item-section>Antworten</q-item-section>
            </q-item>



          </q-list>
        </q-btn-dropdown>
  </q-tabs>
</template>

<script type="ts" setup>
import {ref,watch}  from "vue"
import {useRouter,useRoute}  from "vue-router"
    const props = defineProps({
      id_promotion:String,
      tab:String,
    })
    const router=useRouter()
    const route=useRoute()
    let id_promotion=ref(props.id_promotion)
    let currentTab=ref(props.tab)
    function goto(url){
      router.push(url)
    }
    function changeRoute(data){
      console.log("changeRoute",data)
      let target=data.replace("Promotion","").toLowerCase()
      console.log("xxxx",target)
      router.push("/promotion/"+id_promotion.value+"/"+target)

    }


    watch(() => route.params.tab, (to, from) => {
    console.log(      "cccWatch props.selected function called with args:",      to,      from    );
    })

</script>

<style scoped></style>
